import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RealTimeMinuteService } from '../../minutes/service/real-time-minute.service';
import { ClientMinuteRequestDTO, CompanyDebtorMinuteRequestResolutionDTO, MinuteRequestDetailRealTimeDTO, MinuteRequestResolutionDTO, MinuteRequestSnapshotDTO, OwnersMinuteRequest } from '../../minutes/interface/minute-detail';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import Swal from 'sweetalert2';
import { ScoringIngeService } from '../../../service/scoring-inge.service';
import { MinuteRequestService } from '../../minutes/service/minute-request.service';
import { finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/enviroments';
import { Permissions } from 'src/app/common/permissions';

@Component({
  selector: 'app-qr-minute',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './qr-minute.component.html',
  styleUrls: ['./qr-minute.component.scss'],
})
export class QrMinuteComponent {
  public minutaCargada: boolean = false;
  public hasDicomPermission: boolean;
  public showButtons: boolean = true;
  public showReviewButtons: boolean = false;
  public nminute: number;
  public minute: MinuteRequestDetailRealTimeDTO;
  public minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | null = null;
  public minuteDebtors: CompanyDebtorMinuteRequestResolutionDTO[];
  public resolutionName: string;
  public snapshot: MinuteRequestSnapshotDTO;
  public client: ClientMinuteRequestDTO;
  public owners: OwnersMinuteRequest[] | undefined;
  public cargandoMinuteQR = true;
  public dataSourceOwners: MatTableDataSource<OwnersMinuteRequest>;
  public displayedColumnsOwners: string[] = [
    'socio',
    'participation',
    'civilState',
    'age',
    'aval',
    'rl',
    'sbif',
    'dicom'
  ];

  constructor( private route: ActivatedRoute, private router: Router, public realTimeMinute: RealTimeMinuteService, private authService: AuthService, private scoringIngeService: ScoringIngeService, private minuteRequestService: MinuteRequestService, private cdr: ChangeDetectorRef, private toastrService: ToastrService, private changeDetectorRef: ChangeDetectorRef) {
    this.dataSourceOwners = new MatTableDataSource([]);
    this.minuteDebtors = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minute = null;
    this.client = null;
    this.snapshot = null;
    this.owners = null;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      const { id } = params;
      this.nminute = id;
      this.hasDicomPermission = this.authService.ValidateUserPermission("RequestOwnerPermissions");
      this.getRealTimeInfoMinuteRequest(Number(this.nminute));
      this.mostrarCargando();
    });
  }

  ngOnDestroy(): void {
    this.realTimeMinute.stopConnection();
  }

  public mostrarCargando() {
    Swal.fire({
      title: 'Cargando Minuta',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.minutaCargada = true;
      },
    });
  }

  public getRealTimeInfoMinuteRequest(minuteRequestId: number) {
    this.realTimeMinute.startConnection(minuteRequestId);
      this.realTimeMinute.receivedMinuteDetai$.subscribe({
        next: (response) => {
          if (response) {
            this.setMinuteRequestData(response);
            this.cargandoMinuteQR = false;
            this.changeDetectorRef.detectChanges();
            if(!response.isClosed) {
              this.fetchDebtorResolutions();
            } else {
              this.minuteDebtors = response.snapshot.companyDebtorResolutions||[];
            }
            Swal.close();
          }
        },
        error: (err) => (console.log("Error")),
      });
  }

  public setMinuteRequestData(realTimeMinute: MinuteRequestDetailRealTimeDTO) {
    this.minuteRequestRealTime = realTimeMinute;
    this.client = realTimeMinute?.snapshot.client;
    this.owners = realTimeMinute?.snapshot.client.owners;
    this.resolutionName = realTimeMinute?.finalResolutionName;
    this.dataSourceOwners.data = this.owners;
    this.snapshot = realTimeMinute.snapshot;
    // this.hideButton(realTimeMinute?.resolutions);
    this.showHideResolutionBtn(realTimeMinute);
    this.showHideReviewMinuteBtn(realTimeMinute);
    this.minutaCargada = true;
    console.log("Data Minute QR:", this.minuteRequestRealTime);
  }

  public getDicomPartners() {
    if (!this.hasDicomPermission) {
      Swal.fire({
        title: 'Error',
        text: 'No posee los permisos necesarios para solicitar DICOM',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar'
      })
      return;
    }
    if (this.owners != undefined) {
      var partners = this.owners?.length ?? 0;
      var partnersCompleted = 0;
      for (let i = 0; i < partners; i++) {
        this.scoringIngeService.getDeudaDicom(this.owners[i].fullRut.replace(".", "").replace('.', ''))
          .subscribe({
            next: (response) => {
              if (this.owners != undefined)
                this.owners[i].dicom = response.deuda
              partnersCompleted = partnersCompleted + 1
              if (partnersCompleted == partners)
                this.updateMinutes();
            },
            error(error) {
            }
          })
      }
    }
  }

  public redirectMinute() {
    if(this.nminute <= environment.nminutelimitold) 
    {
      this.redirectToOldMinute(this.nminute);
    }
    else
    {
      this.redirectToNewMinute(this.nminute);
    }
  }

  public redirectToOldMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/old-minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public redirectToNewMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/minute'], { queryParams: { id: + minuteRequestId, forceDesktop: 'true' } });
    /*this.router.navigate(['dashboards/minute'], {
      queryParams: { id: +minuteRequestId },
    });*/
  }

  updateMinutes() {
    Swal.fire({
      text: 'Se estan actualizando los datos',
      icon: 'info',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestService
          .updateMinuteSnapshot(this.nminute)
          .pipe(finalize(() => (console.log("Minuta Actualizada"))))
          .subscribe({
            next: (response: MinuteRequestSnapshotDTO) => {
              Swal.fire({
                'title': 'Minuta actualizada',
                text: 'Se ha actualizado exitosamente los datos de la minuta',
                icon: 'success',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar'
              })
            },
            error: (err) => {
              Swal.fire({
                title: 'Error',
                text: 'No fue posible actualizar la minuta',
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar'
              })
            }
          });
      }
    })
  }

  public hideButton(userResolution: MinuteRequestResolutionDTO[]) {
    const user = this.authService.getNameIdentifier();
    userResolution?.filter((response) => {
      const filtro = response.userName.includes(user);
      if (
        this.minuteRequestRealTime.finalResolutionName == 'Pendiente' &&
        filtro == false
      ) {
        this.showButtons = true;
      } else {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Aprobado') {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Rechazado') {
        this.showButtons = false;
      }
    });
  }

  public showHideResolutionBtn(minuteRequest: MinuteRequestDetailRealTimeDTO) {
    if(!(minuteRequest.finalResolution === 1 || minuteRequest.finalResolution === 9)){
      this.showButtons = false;
      return;
    }
    const userName = this.authService.getNameIdentifier();
    const isAlreadyProvided = minuteRequest.resolutions
    .findIndex(r => r.userName == userName);
    if(isAlreadyProvided >= 0) {
      this.showButtons = false;
      return;
    }
    this.showButtons = true;
  }

  public showHideReviewMinuteBtn(minute: MinuteRequestDetailRealTimeDTO) {
    const isMinutePreApproved = minute?.finalResolution === 8;
    const hasPermission = this.authService.getUserPermissions().includes(Permissions.ReviewMinuteSpecialCondition);
    this.showReviewButtons = isMinutePreApproved && hasPermission;
  }

  public fetchDebtorResolutions() {
    this.realTimeMinute.receivedMinuteDebtorResolutions$.subscribe({
      next:(debtorResolutions) => {
        this.minuteDebtors = debtorResolutions;
      }
    })
  }

  approveMinuteConfirm() {
    Swal.fire({
      icon: 'question',
      titleText: '¿Deseas Aprobar esta Minuta?',
      text: 'Ingresa algún comentario (Opcional)',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.approveMinute(this.nminute, result.value);
        //this.accessButton();
      }
    });
  }

  approveMinute(id: number, coment: any) {
    this.minuteRequestService.approveMinute(id, coment).subscribe({
      next: (response) => {
        this.toastrService.success(response.message);
        this.getRealTimeInfoMinuteRequest(id);
      },
      error: (err) => {
        this.toastrService.error(err.error.message);
      },
    });
  }

  rejecMinuteConfirm() {
    Swal.fire({
      icon: 'question',
      titleText: '¿Rechaza la Minuta?',
      text: 'Indica por que se rechaza la minuta',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Rechazar',
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.rejectMinute(this.nminute, result.value);
        //this.accessButton();
      }
    });
  }

  rejectMinute(id: number, coment) {
    this.minuteRequestService.rejectMinute(id, coment).subscribe({
          next: (response) => {
            this.toastrService.success(response.message);
            this.getRealTimeInfoMinuteRequest(id);
          },
          error: (err) => {
            this.toastrService.error(err.error.message);
          },
        });
  }

  approveReviewMinuteConfirm() {
    Swal.fire({
      icon: 'question',
      titleText: '¿Aprobar revisión de minuta?',
      text: 'Ingresa algún comentario (Opcional)',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },

    }).then((result) => {
      if(result.isConfirmed) {
        this.approveReviewMinute(this.nminute, result.value)
      }
    })
  }

  approveReviewMinute(minuteId:number, comment: string | null) {
    this.minuteRequestService.approveReviewMinute(minuteId, comment)
    .subscribe({
      next:(res) => {
        this.toastrService.success(res.message)
      },
      error: (err) => {
        this.toastrService.error(err.error.message)
      }
    })
  }

  getReportUrl(rut:string){
    var rutformat = rut.split('.').join('');
    var parametros =
      '{"Token":"IngeInternalApiKey55","Rut":"' + rutformat + '"}';
    var base64Datos = window.btoa(parametros);
    return 'https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/' + base64Datos;
  }

  closeMinuteConfirmation() {
    Swal.fire({
      title: 'Enviar a comité',
      text: '¿Estás seguro que desea enviar esta minuta a comité?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.closeMinuteRequest(this.nminute);
        // this.accessButton();
      }
    });
  }

  public accessButton() {
    const permissionsUsers = this.authService.getUserPermissions()
      .filter(e => {
        return e.includes("UpdateClient")
      })
    if (permissionsUsers.length > 0) {
      this.showButtons = true
    } else {
      this.showButtons = false

    }
  }

  private closeMinuteRequest(minuteRequestId: number): void {
    this.minuteRequestService.sendMinuteRequestToComitee(minuteRequestId).subscribe({
      next: (response) => {
        this.toastrService.success(response.resultMessage);
      },
      error: (err) => {
        this.toastrService.error(err.error.resultMessage);
      },
    });
  }

  /*public redirectToMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/pdf'], {
      queryParams: { id: +minuteRequestId },
    });
  }*/

}